import { render, staticRenderFns } from "./ResponsibleEmail.vue?vue&type=template&id=49d82ef6&"
import script from "./ResponsibleEmail.vue?vue&type=script&lang=js&"
export * from "./ResponsibleEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports